module.exports = __webpack_public_path__ + "images/store_case_study/navikaden-pic1_706335fb0252f969b7f2be892d3e88d3.png";